import Text from './TextComponent';

export default Text;
